export default __webpack_public_path__ + "static/media/neutralFace.5cf47b77.svg";